var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 25",
    className: "warning_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.782 17.099 13.79 7.095c-.737-1.475-2.843-1.475-3.58 0L5.219 17.1a2 2 0 0 0 1.79 2.893h9.985a2 2 0 0 0 1.79-2.893zM15.58 6.202c-1.473-2.951-5.685-2.951-7.158 0L3.428 16.205c-1.327 2.66.607 5.787 3.58 5.787h9.985c2.972 0 4.906-3.127 3.579-5.787L15.579 6.202z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.992a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0v-4zm-1 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
    fill: "currentColor"
  })));
};

export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNSIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4Ljc4MiAxNy4wOTlMMTMuNzkgNy4wOTVjLS43MzctMS40NzUtMi44NDMtMS40NzUtMy41OCAwTDUuMjE5IDE3LjFhMiAyIDAgMDAxLjc5IDIuODkzaDkuOTg1YTIgMiAwIDAwMS43OS0yLjg5M3pNMTUuNTggNi4yMDJjLTEuNDczLTIuOTUxLTUuNjg1LTIuOTUxLTcuMTU4IDBMMy40MjggMTYuMjA1Yy0xLjMyNyAyLjY2LjYwNyA1Ljc4NyAzLjU4IDUuNzg3aDkuOTg1YzIuOTcyIDAgNC45MDYtMy4xMjcgMy41NzktNS43ODdMMTUuNTc5IDYuMjAyeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTEzIDguOTkyYTEgMSAwIDEwLTIgMHY0YTEgMSAwIDEwMiAwdi00em0tMSA3YTEgMSAwIDEwMCAyIDEgMSAwIDAwMC0yeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";